import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { T } from "../constants/theme";

export default function AccordionRow({ title, isOpen, onToggle, children }) {
  return (
    <div style={{ borderBottom: `1px solid ${T.border}` }}>
      <button
        onClick={onToggle}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "none",
          border: "none",
          padding: "18px 0",
          cursor: "pointer",
          fontWeight: 700,
          letterSpacing: ".12em",
          textTransform: "uppercase",
          fontSize: 13,
          color: T.ink,
        }}
      >
        {title}
        {isOpen ? <FiChevronUp /> : <FiChevronDown />}
      </button>

      {isOpen && (
        <div
          style={{
            paddingBottom: 22,
            color: T.muted,
            lineHeight: 1.8,
            fontSize: 14,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
